/**
 * @des 设备判断
 */

// 判断当前设备是否是 Android
export function isAndroid() {
    const UA = navigator.userAgent;
    return UA.indexOf('Android') > -1 || UA.indexOf('Adr') > -1;
}

export function isIOS() {
    if (typeof window !== 'undefined' && window) {
        const UA = navigator.userAgent;
        return /iPad|iPhone|iPod/.test(UA) && !window.MSStream;
    }
    return false;
}

export function isTuchongApp() {
    if (typeof window !== 'undefined' && window) {
        const UA = navigator.userAgent;
        return UA.toLocaleLowerCase().indexOf('tuchong') !== -1;
    }
    return false;
}

// export const isTuchongApp = navigator.userAgent.toLocaleLowerCase().indexOf('tuchong') !== -1;

// 微信
export function isWeixinBrowser() {
    const UA = navigator.userAgent;
    return /micromessenger/.test(UA.toLowerCase());
}

// 抖音
export function isDouyin() {
    const HREF = window.location.href;
    return HREF.indexOf('douyin') >= 0;
}

// 时光相册
export function isSgxc() {
    const HREF = window.location.href;
    return HREF.indexOf('shiguangxiangce') >= 0;
}

// 时光相册
export function isXgsp() {
    const HREF = window.location.href;
    return HREF.indexOf('xiguashipin') >= 0;
}

export function getPlatform() {
    if (isAndroid()) {
        return 'android';
    }

    if (isIOS()) {
        return 'ios';
    }
    return 'unknown';
}
